import * as React from "react";
import { useEffect, useRef, useState } from "react";
import CustomTable from "../shared/table/Table";
import ModalComponent from "../shared/Modal";
import { Forms } from "../shared/forms/forms";
import { Switch, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  makeStyles, } from "@material-ui/core";
import EventNoteIcon from '@mui/icons-material/EventNote';
import Box from "@mui/material/Box";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Navigate } from "react-router-dom";
import {
  addEmployeeLogin,
  createEmployee,
  deleteEmployee,
  getEmployeeById,
  getEmployees,
  removeEmployeeLogin,
  resetEmployeePassword,
  updateEmployee,
} from "../services/employee-service";
import { getEquipmentByCategory } from "../services/equipment-service";
import { formatDate } from "../utils/date-functions.js";
import { useAuth } from "../hooks/useAuth";
import { createNote, deleteNote, getAllNotesByEmployeeId, updateNote } from "../services/notes-service.js";

const resetPasswordFields = [
  {
    label: "Set Password",
    type: "password",
    name: "password",
    required: true,
    value: "",
    size: 12,
  },
  {
    label: "ID",
    type: "hidden",
    name: "id",
    required: true,
    size: 12,
  },
];

const loginFields = [
  {
    label: "Username",
    type: "text",
    name: "username",
    required: true,
    value: "",
    size: 12,
  },
  {
    label: "Set Password",
    type: "password",
    name: "password",
    required: true,
    value: "",
    size: 12,
  },
  {
    label: "Ticket Identifier",
    type: "text",
    name: "ticketIdentifier",
    required: true,
    size: 12,
  },
];

const columnData = [
  { accessorKey: "firstName", header: "First Name" },
  { accessorKey: "lastName", header: "Last Name" },
  { accessorKey: "jobTitleDisplay", header: "Job Title" },
  { accessorKey: "hireDate", header: "Hire Date" },
  { accessorKey: "terminationDate", header: "Termination Date" },
  { accessorKey: "doB", header: "DoB" },
];

export const EmployeesPage = () => {
  // 1) Make loginFields editable
  const [loginFieldsState, setLoginFieldsState] = useState(loginFields);

  // 2) Track whether the password field is visible
  const [showPassword, setShowPassword] = useState(false);

  // 3) A quick password generator
  const generatePassword = () => {
    const length = 16;
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
      "abcdefghijklmnopqrstuvwxyz" +
      "0123456789" +
      "!@#$%^&*()_+[]{}|;:,.<>?";
    let pwd = "";
    for (let i = 0; i < length; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    // update the password field in our state
    setLoginFieldsState((fields) =>
      fields.map((f) =>
        f.name === "password" ? { ...f, value: pwd } : f
      )
    );
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [activeEmployees, setActiveEmployees] = useState(true);
  const [fields, setFields] = useState(defaultEmployee);
  const [currentEmployeeIndex, setCurrentEmployeeIndex] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [currentEmployee, setCurrentEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [updatedEmployeeData, setUpdatedEmployeeData] = useState([]);
  const [notes, setNotes] = useState([]);
  const [removeLoginModalOpen, setRemoveLoginModalOpen] = useState(false);
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);
  const [addLoginModalOpen, setAddLoginModalOpen] = useState(false);
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [rigList, setRigList] = useState([]);
  const ref = useRef();
  const { role } = useAuth();

  if (role && role !== "admin") {
    return <Navigate to="/dashboard/homepage" replace />;
  }


  const getRigList = (equipmentId) => {
    getEquipmentByCategory(equipmentId).then((resData) => setRigList(resData));
  };
  useEffect(() => {
    getAllEmployees();
    getRigList(1);
  }, []);

  
  const selectRig = rigList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  selectRig.unshift({
    value: null,
    label: "NO RIG",
  });

  const handleOpenModal = (edit) => {
    setEditMode(edit);
    setModalTitle(edit ? "Edit Employee" : "Create Employee");
    if (!edit) {
      setFields(defaultEmployee);
    }
    setModalOpen(true);
  };

  const handleOpenNoteModal = (data) => {
    getAllNotesByEmployeeId(data.id).then((resData) => {
      setCurrentEmployeeIndex(data.id);
      setNotes(resData);
      setNotesModalOpen(true);
    });
  };

  const getEmployeeFields = (employee) => {
    return defaultEmployee
      .filter((field) => field.name !== "id")
      .map((field) => ({
        ...field,
        value: employee[field.name],
      }));
  };

  const handleConfirmAction = () => {
    ref.current.submit();
  };

  const handleCloseModal = () => {
    setEditMode(false);
    setModalOpen(false);
    setModalTitle("");
    setSelectedEmployee(null);
  };

  const handleDeleteConfirmAction = () => {
    removeEmployee(currentEmployeeIndex);
  };

  const handleDeleteCloseModal = () => {
    setDeleteModalOpen(false);
  };

  const handleNoteCloseModal = () => {
    setNotesModalOpen(false);
  }

  const defaultEmployee = [
    {
      label: "First Name",
      type: "text",
      name: "firstName",
      required: true,
      value: "",
      size: 6,
    },
    {
      label: "Last Name",
      type: "text",
      name: "lastName",
      value: "",
      required: true,
      size: 6,
    },
    {
      label: "Email",
      type: "text",
      name: "email",
      required: false,
      email: true,
      value: "",
      size: 6,
    },
    {
      label: "Phone",
      type: "text",
      name: "phone",
      required: false,
      email: false,
      mask: true,
      masked: "(999) 999-9999",
      value: "",
      size: 6,
    },
    {
      label: "Pay Rate",
      type: "text",
      name: "payRate",
      required: true,
      value: "",
      size: 6,
      numbersOnly : true
    },
    {
      label: "Job Title",
      type: "select",
      name: "jobTitle",
      required: true,
      selectOptions: [
        { label: "Tool Pusher", value: "ToolPusher" },
        { label: "Crew Chief", value: "CrewChief" },
        { label: "Derrick Man", value: "DerrickMan" },
        { label: "Floor Hand", value: "FloorHand" },
      ],
      value: "",
      size: 6,
    },
    {
      label: "Date of Birth",
      type: "datetime",
      name: "doB",
      required: false,
      value: null,
      size: 6,
    },
    {
      label: "Assigned Rig",
      type: "select",
      name: "assignedRigId",
      required: false,
      selectOptions: selectRig,
      value: null,
      size: 6,
    },
    {
      label: "Employee Number",
      type: "text",
      name: "employeeNumber",
      required: true,
      value: "",
      size: 6,
    },
    {
      label: "SSN",
      type: "text",
      name: "ssn",
      required: false,
      value: "",
      mask: true,
      masked: "999-99-9999",
      size: 6,
    },
    {
      label: "Address",
      type: "text",
      name: "address",
      required: false,
      value: "",
      size: 6,
    },
    {
      label: "City",
      type: "text",
      name: "city",
      required: false,
      value: "",
      size: 6,
    },
    {
      label: "State",
      type: "text",
      name: "state",
      required: false,
      value: "",
      size: 6,
    },
    {
      label: "Zip",
      type: "number",
      name: "zip",
      required: false,
      value: "",
      size: 6,
    },
    {
      label: "Hire Date",
      type: "datetime",
      name: "hireDate",
      required: true,
      value: new Date(),
      size: 6,
    },
    {
      label: "Termination Date",
      type: "datetime",
      name: "terminationDate",
      required: false,
      value: "",
      size: 6,
    },
  ];

  const actions = [
    {
      onClick: handleConfirmAction,
      color: "primary",
      label: "Confirm",
      variant: "contained",
    },
    {
      onClick: handleCloseModal,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  const deleteActions = [
    {
      onClick: handleDeleteConfirmAction,
      color: "primary",
      label: "Confirm",
      variant: "contained",
    },
    {
      onClick: handleDeleteCloseModal,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  const noteActions = [
    {
      onClick: handleNoteCloseModal,
      color: "primary",
      label: "Confirm",
      variant: "contained",
    }
  ];

  

  const handleAddAction = () => {
    handleOpenModal(false);
  };

  const handleEditAction = ( data ) => {
    setCurrentEmployeeIndex(data.id);
    getEmployeeById(data.id).then((employee) => {
      setEditMode(true);
      setModalTitle("Edit Employee");
      setCurrentEmployeeIndex(employee.id);
      setCurrentEmployee(employee);
      setFields(getEmployeeFields(employee));
      setModalOpen(true);
    });
  };

  const handleDeleteAction = (data ) => {
    const id = data.id;
    setCurrentEmployeeIndex(id);
    setDeleteModalOpen(true);
  };

  const handleResetPassword = () => {
    setResetPasswordModalOpen(true);
  };

  const handleAddLogin = () => {
    setLoginFieldsState(loginFields); 
    setShowPassword(false);
    setAddLoginModalOpen(true);
  };

  const loginFieldsForRender = loginFieldsState.map((f) =>
    f.name === "password"
      ? { ...f, type: showPassword ? "text" : "password" }
      : f
  );

  const handleRemoveLogin = () => {
    setRemoveLoginModalOpen(true);
  };

  const handleCloseLoginModal = () => {
    setAddLoginModalOpen(false);
  };

  const handleCloseRemoveLoginModal = () => {
    setRemoveLoginModalOpen(false);
  };

  const handleCancelRemoveLogin = () => {
    handleCloseRemoveLoginModal(false);
  };
  const handleCloseResetPasswordModal = () => {
    setResetPasswordModalOpen(false);
  };

  const handleConfirmResetPassword = (data) => {
    const employeeData = {
      password: data.password,
    };
    employeeData.id = currentEmployeeIndex;
    resetEmployeePassword(employeeData).then(() => {
      handleCloseResetPasswordModal();
      handleCloseModal();
    });
  };

  const handleConfirmRemoveLogin = async () => {
    removeLoginEmployee(currentEmployeeIndex);
    setDeleteModalOpen(false);
  };

  const handleLoginAction = (data) => {
    data.id = currentEmployee.id;
    addLoginEmployee(data);
    handleCloseLoginModal();
    handleCloseModal();
  };

  const onFormSubmit = (data) => {

    if (editMode) {
      data.id = currentEmployeeIndex;
      editEmployee(data);
    } else {
      createNewEmployee(data);
    }
  };

  const addLoginEmployee = (employee) => {
    addEmployeeLogin(employee).then(() => {
      handleCloseLoginModal();
      handleCloseModal();
    });
  };

  const removeLoginEmployee = (employeeId) => {
    removeEmployeeLogin(employeeId).then(() => {
      handleCloseRemoveLoginModal(false);
      handleCloseModal();
    });
  };

  const removeEmployee = (employeeId) => {
    deleteEmployee(employeeId).then(() => {
      setDeleteModalOpen(false);
      getAllEmployees();
    });
  };

  const editEmployee = (employee) => {
    if (!employee.assignedRigId) {
      employee.assignedRigId = null;
    }
    updateEmployee(employee).then(() => {
      handleCloseModal();
      getAllEmployees();
    });
  };

  const createNewEmployee = (employee) => {
    if (!employee.assignedRigId) {
      employee.assignedRigId = null;
    }
    createEmployee(employee).then(() => {
      handleCloseModal();
      getAllEmployees();
    });
  };

  const getAllEmployees = () => {
    getEmployees(activeEmployees).then((employees) => {
      setUpdatedEmployeeData(employees);
    });
  };

  const setEmployeesFilter = () => {
    if (activeEmployees) {
      showInactiveEmployees();
    } else {
      showActiveEmployees();
    }
    setActiveEmployees(!activeEmployees);
  };

  const handleOnRowClick = () => { };

  const showActiveEmployees = () => {
    getEmployees().then((employees) => {
      setEmployeeData(employees);
      setUpdatedEmployeeData(employees);
    });
  };

  const showInactiveEmployees = () => {
    getEmployees(false).then((employees) => {
      setEmployeeData(employees);
      setUpdatedEmployeeData(employees);
    });
  };

  const employeeActionRenderer = (row, index, cell) => {
    return (
      <>
      {<Tooltip title="Edit" arrow>
        <EditIcon fontSize="small" onClick={() => handleEditAction(row.original)} style={{ cursor: 'pointer' }} />
      </Tooltip>}
      {<Tooltip title="Delete" arrow>
          <DeleteIcon fontSize="small" onClick={() => handleDeleteAction(row.original)} style={{ marginLeft: '10px', cursor: 'pointer' }} />
      </Tooltip>}
      {<Tooltip title="Note" arrow>
          <EventNoteIcon fontSize="small" onClick={() => handleOpenNoteModal(row.original)} style={{ marginLeft: '10px', cursor: 'pointer' }} />
      </Tooltip>}
      </>
    );
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "10px",
          position: "absolute",
          top: "100px",
        }}
      >
        <Switch
          value={activeEmployees}
          checked={activeEmployees}
          onChange={setEmployeesFilter}
        />
        <h5>Show Active Employees</h5>
      </div>
      <CustomTable
        tableName={activeEmployees ? "Active Employees" : "Inactive Employees"}
        columns={columnData}
        data={updatedEmployeeData.map((employee) => ({
          firstName: employee.firstName,
          lastName: employee.lastName,
          jobTitleDisplay: employee.jobTitleDisplay,
          hireDate: formatDate(employee.hireDate),
          terminationDate: formatDate(employee.terminationDate),
          doB: formatDate(employee.doB),
          id: employee.id,
        }))}
        visibility={{
          terminationDate: activeEmployees ? false : true
        }}
        rowsPerPageOptions={[20]}
        showDelete={true}
        showEdit={true}
        onAdd={handleAddAction}
        rowActionRendererer={employeeActionRenderer}
      />

      <ModalComponent
        open={modalOpen}
        onClose={handleCloseModal}
        title={modalTitle}
        actions={actions}
        closeOnOutsideClick={false}
      >
        <Forms
          ref={ref}
          fields={fields}
          onSubmit={(data) => onFormSubmit(data)}
        />

        {editMode && !currentEmployee.hasLogin && (
          <Button onClick={handleAddLogin} color="primary" variant="contained">
            Add Login
          </Button>
        )}
        {editMode && currentEmployee.hasLogin && (
          <Button
            onClick={handleRemoveLogin}
            color="primary"
            variant="contained"
            style={{ marginRight: "15px" }}
          >
            Remove Login
          </Button>
        )}
        {editMode && currentEmployee.hasLogin && (
          <Button
            onClick={handleResetPassword}
            color="primary"
            variant="contained"
          >
            Reset password
          </Button>
        )}
        <ModalComponent
          open={resetPasswordModalOpen}
          onClose={handleCloseResetPasswordModal}
          title="Reset Password"
          actions={[
            {
              onClick: handleConfirmResetPassword,
              color: "primary",
              label: "Reset Password",
              variant: "contained",
            },
            {
              onClick: handleCloseResetPasswordModal,
              color: "default",
              label: "Cancel",
              variant: "outlined",
            },
          ]}
          closeOnOutsideClick={false}
        >
          <Forms
            fields={resetPasswordFields}
            onSubmit={handleConfirmResetPassword}
          />
        </ModalComponent>

        <ModalComponent
          open={addLoginModalOpen}
          onClose={handleCloseLoginModal}
          title="Add Login"
          actions={[
            {
              onClick: () => ref.current.submit(),
              color: "primary",
              label: "Confirm",
              variant: "contained",
            },
            {
              onClick: handleCloseLoginModal,
              color: "default",
              label: "Cancel",
              variant: "outlined",
            },
          ]}
          closeOnOutsideClick={false}
        >
          <Box display="flex" alignItems="center" mb={2}>
          
          <Switch
            checked={showPassword}
            onChange={() => setShowPassword((v) => !v)}
            size="small"
          />
          <Typography variant="caption">Show Password</Typography>
        </Box>
        <Forms
          ref={ref}
          fields={loginFieldsForRender}
          onSubmit={handleLoginAction}
        />
        </ModalComponent>

        <ModalComponent
          open={removeLoginModalOpen}
          onClose={handleCloseRemoveLoginModal}
          title="Remove Login"
          actions={[
            {
              onClick: handleConfirmRemoveLogin,
              color: "primary",
              label: "Confirm",
              variant: "contained",
            },
            {
              onClick: handleCancelRemoveLogin,
              color: "default",
              label: "Cancel",
              variant: "outlined",
            },
          ]}
          closeOnOutsideClick={false}
        >
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <HighlightOffIcon
              style={{ margin: "auto", fontSize: "58px", color: "red" }}
            />
            <Typography
              style={{ fontSize: "24px", textAlign: "center", margin: "15px" }}
            >
              Are you sure?
            </Typography>
            <Typography
              style={{ fontSize: "14px", textAlign: "center", color: "grey" }}
            >
              Do you really want to delete this employee login? <br />
              The process cannot be undone.
            </Typography>
          </Box>
        </ModalComponent>
      </ModalComponent>

      <ModalComponent
        open={deleteModalOpen}
        onClose={handleDeleteCloseModal}
        title="Delete Employee"
        actions={deleteActions}
        closeOnOutsideClick={false}
      >
        <Box style={{ display: "flex", flexDirection: "column" }}>
          <HighlightOffIcon
            style={{ margin: "auto", fontSize: "58px", color: "red" }}
          />
          <Typography
            style={{ fontSize: "24px", textAlign: "center", margin: "15px" }}
          >
            Are you sure?
          </Typography>
          <Typography
            style={{ fontSize: "14px", textAlign: "center", color: "grey" }}
          >
            Do you really want to delete this employee? <br />
            The process cannot be undone.
          </Typography>
        </Box>
      </ModalComponent>
      <ModalComponent
        open={notesModalOpen}
        onClose={handleNoteCloseModal}
        title="Employee Notes"
        actions={noteActions}
        closeOnOutsideClick={false}
      >
       <ViewNotes 
       ref = {ref}
       notes = {notes}
       setNotes = {setNotes}
       employeeIndex = {currentEmployeeIndex}
       />
      </ModalComponent>
    </>
  );
};

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  actionCell: {
    textAlign: "end",
    verticalAlign: "middle",
  },
  tableContainer: {
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  tableHeaderCell: {
    backgroundColor: "#f2f2f2",
    color: "#333",
    fontWeight: "bold",
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fbfafa",
    },
  },
});

export const ViewNotes = React.forwardRef(({
  notes,
  employeeIndex,
  setNotes
},ref) => {
  const [noteEditModalOpen, setNoteEditModalOpened] = useState(false);
  const [noteDeleteModalOpen, setNoteDeleteModalOpened] = useState(false);
  const [editNoteFields, setEditNoteFields] = useState([]);
  const [currentTicketId, setCurrentTicketId] = useState("");
  const [noteAddModalOpen, setNoteAddModalOpened] = useState(false);
  const [addNoteFields, setAddNoteFields] = useState([]);
  const [noteId, setNoteId] = useState("");
  const classes = useStyles();

  const columnNoteData = [
  { accessorKey: "ticketId", header: "Ticket Name"},
  { accessorKey: "noteContent", header: "Note Content"},
];

  const handleConfirmAction = () => {
    ref.current.submit();
  };

  const createNoteFields = (data) =>{
    let editNoteFields;
    editNoteFields = [
        {
          label: "Note content",
          type: "textarea",
          name: "noteContent",
          value: data,
          size: 12
        }
      ];
    setEditNoteFields(editNoteFields);
  };

  const createAddNoteFields = () =>{
    let payrollNoteFields;
      payrollNoteFields = [
        {
          label: "Note content",
          type: "textarea",
          name: "noteContent",
          size: 12
        }
      ];
      setAddNoteFields(payrollNoteFields);
  };

  const onEditNoteAction = (data) => {
    createNoteFields(data.noteContent);
    setCurrentTicketId(data.ticketId);
    setNoteId(data.id);
    setNoteEditModalOpened(true);
  }

  const onAddNoteAction = () => {
    createAddNoteFields();
    setNoteAddModalOpened(true);
  }

  const handleNoteDeleteAction = (data) => {
    setNoteId(data.id)
    setNoteDeleteModalOpened(true); 
  }

  const onNoteEditModalClosed = () => {
    getAllNotesByEmployeeId(employeeIndex).then((resData) => {
      setNotes(resData);
      setNoteEditModalOpened(false);
    });
  };

  const onNoteAddModalClosed = () => {
    getAllNotesByEmployeeId(employeeIndex).then((resData) => {
      setNotes(resData);
      setNoteAddModalOpened(false);
    });
  };

  const onNoteDeleteModalClosed = () => {
    getAllNotesByEmployeeId(employeeIndex).then((resData) => {
      setNotes(resData);
      setNoteDeleteModalOpened(false);
    });
  };

  const onEditNoteSubmitted = (data) => {
    let reqBody;
    reqBody = {
      ticketId : currentTicketId,
      employeeId: employeeIndex,
      noteContent: data.noteContent,
      Id : noteId,
    };
    updateNote(reqBody).then(() => {onNoteEditModalClosed();});
  };

  const onAddNoteSubmitted = (data) => {
    let reqBody;
    reqBody = {
      ticketId: null,
      employeeId: employeeIndex,
      noteContent: data.noteContent,
    };
    createNote(reqBody).then((data) => {onNoteAddModalClosed();});
  };

  const onNoteDeleteActionConfirmed = () => {
    deleteNote(noteId).then((data) => {onNoteDeleteModalClosed();});
  };


  const editNoteActions = [
    {
      onClick: handleConfirmAction,
      color: "primary",
      label: "Confirm",
      variant: "contained",
    },
    {
      onClick: onNoteEditModalClosed,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  const addNoteActions = [
    {
      onClick: handleConfirmAction,
      color: "primary",
      label: "Confirm",
      variant: "contained",
    },
    {
      onClick: onNoteAddModalClosed,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  const deleteNoteActions = [
    {
      onClick: onNoteDeleteActionConfirmed,
      color: "primary",
      label: "Confirm",
      variant: "contained",
    },
    {
      onClick: onNoteAddModalClosed,
      color: "default",
      label: "Cancel",
      variant: "outlined",
    },
  ];

  return (
  <>
      <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableBody>
              {notes.map((row,index) => (
                <TableRow key={row} className={classes.tableRow}>
                  <TableCell>{row.ticketId ? row.ticketName : "Manager Ticket" }</TableCell>
                  <TableCell>{row.noteContent}</TableCell>
                  <TableCell className={classes.actionCell}>
                    <EditIcon
                      onClick={() => {
                        onEditNoteAction(row)}}
                      aria-label="edit"
                      style={{ cursor: "pointer" }}
                    />
                    <DeleteIcon
                      onClick={() => {
                        handleNoteDeleteAction(row)}}
                      aria-label="delete"
                      style={{ cursor: "pointer" }}
                    />
                     </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
          <Button
          color="primary"
          variant="contained"
          style={{ marginTop: "15px" }}
          startIcon={<AddIcon fontSize="small" style={{ fontWeight: 'bold' }} />}
          onClick={() => onAddNoteAction()}
          >
            ADD NOTE
          </Button>
        <ModalComponent
        open={noteEditModalOpen}
        onClose={onNoteEditModalClosed}
        title={"Edit Note"}
        actions={editNoteActions}
        closeOnOutsideClick={false}
      >
        <Forms
          ref={ref}
          fields={editNoteFields}
          onSubmit={(data) => onEditNoteSubmitted(data)}
        />
      </ModalComponent>
      <ModalComponent
        open={noteAddModalOpen}
        onClose={onNoteAddModalClosed}
        title={"Add Note"}
        actions={addNoteActions}
        closeOnOutsideClick={false}
      >
        <Forms
          ref={ref}
          fields={addNoteFields}
          onSubmit={(data) => onAddNoteSubmitted(data)}
        />
      </ModalComponent>
      <ModalComponent
        open={noteDeleteModalOpen}
        onClose={onNoteDeleteModalClosed}
        title={"Are you sure you want to delete this note?"}
        actions={deleteNoteActions}
        closeOnOutsideClick={false}
      >
        <Box style={{ display: "flex", flexDirection: "column" }}>
          <HighlightOffIcon
            style={{ margin: "auto", fontSize: "58px", color: "red" }}
          />
          <Typography
            style={{
            fontSize: "24px",
            textAlign: "center",
            margin: "15px",
            }}
          >
          Are you sure?
          </Typography>
          <Typography
          style={{
            fontSize: "14px",
            textAlign: "center",
            color: "grey",
            }}
          >
            Are you sure you want to delete this note entry? <br />
            The process cannot be undone.
          </Typography>
        </Box>
      </ModalComponent>
  </>);
});
